import formatDate from "./formatDate";
import { resumeStyles } from "./resume-style";
import { Document, Page, Text, View } from "@react-pdf/renderer";

export const Resume = ({ profileData }) => (
  <Document
    creator="Search O Pal"
    producer="Search O Pal"
    title={`${profileData?.name} - CV`}
  >
    <Page style={resumeStyles.page} title={"My Profile"}>
      <View style={resumeStyles.section}>
        <Text style={resumeStyles.header1}>{profileData?.name}</Text>
        <Text style={resumeStyles.header2}>{profileData?.designation}</Text>
        <Text style={resumeStyles.initialInfo}>{profileData?.email}</Text>
        <Text style={resumeStyles.initialInfo}>{profileData?.phone}</Text>
        <Text style={resumeStyles.initialInfo}>{profileData?.gender}</Text>
        <Text style={resumeStyles.initialInfo}>
          {profileData?.city && profileData?.city + ", "}
          {profileData?.country}
        </Text>
        <Text style={resumeStyles.initialInfo}>{profileData?.about_me}</Text>
        {profileData?.website && <Text style={resumeStyles.initialInfo}>{profileData?.website}</Text>}
        {profileData?.github_profile && <Text style={resumeStyles.initialInfo}>{profileData?.github_profile}</Text>}
      </View>

      {/* ===== Work Experience Section ===== */}

      {profileData?.work_experiences?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <View style={resumeStyles.watermark}>
            <Text style={resumeStyles.watermarkText}>Prepared with Search O Pal</Text>
          </View>
          <Text style={resumeStyles.subheader}>Work Experience</Text>
          {profileData.work_experiences.map((exp, idx) => (
            <View key={idx} style={{ marginBottom: "10px" }}>
              <Text style={resumeStyles.text1}>{exp.role}</Text>
              <Text style={resumeStyles.text2}>
                {exp.company} - {exp.city}, {exp.country}
              </Text>
              <Text style={resumeStyles.text2}>
                {formatDate(exp.start_date)} -{" "}
                {exp.end_date ? formatDate(exp.end_date) : "Currently Working"}
              </Text>
              <Text style={resumeStyles.description}>{exp.description}</Text>
              {exp?.projects?.length > 0 && <Text style={resumeStyles.text1}>Projects</Text>}
              {exp?.projects?.length > 0 &&
                exp.projects.map((project, proj_id) => (
                  <View key={idx} style={{ marginBottom: "10px" }}>
                    <Text style={resumeStyles.ul}>{`${proj_id + 1}- ${project.title}`}</Text>
                    <Text style={resumeStyles.li_description}>
                      {parseHtmlToPdf(project.responsibilities, {
                        h1: resumeStyles.text1,
                        h2: resumeStyles.text2,
                        h3: resumeStyles.text2,
                        h4: resumeStyles.text2,
                        h5: resumeStyles.text2,
                        h6: resumeStyles.text2,
                        p: resumeStyles.description,
                        strong: resumeStyles.strong,
                        italic: resumeStyles.italic,
                        ul: resumeStyles.ul,
                        li: resumeStyles.li,
                        br: resumeStyles.br,
                      })}
                    </Text>
                    <Text style={resumeStyles.li_description}>{parseHtmlToPdf(project.description, {
                      h1: resumeStyles.text1,
                      h2: resumeStyles.text2,
                      h3: resumeStyles.text2,
                      h4: resumeStyles.text2,
                      h5: resumeStyles.text2,
                      h6: resumeStyles.text2,
                      p: resumeStyles.description,
                      strong: resumeStyles.strong,
                      italic: resumeStyles.italic,
                      ul: resumeStyles.ul,
                      li: resumeStyles.li,
                      br: resumeStyles.br,
                    })}</Text>
                    {project?.skills?.length > 0 && <Text style={resumeStyles.li_description}>Skills</Text>}
                    {project?.skills?.length > 0 &&
                      project.skills.map((skill) => (
                        <View key={idx}>
                          <Text style={resumeStyles.li}>{`• ${skill.skill}`}</Text>
                        </View>
                      ))
                    }
                  </View>
                ))}
            </View>
          ))}
        </View>
      }

      {/* ===== Projects Section ===== */}

      {profileData?.projects?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <Text style={resumeStyles.subheader}>Projects</Text>
          {profileData.projects.map((project, idx) => (
            <View key={idx} style={{ marginBottom: "10px" }}>
              <Text style={resumeStyles.text1}>{project.title}</Text>
              <Text style={resumeStyles.text2}>
                {parseHtmlToPdf(project.responsibilities, {
                  h1: resumeStyles.text1,
                  h2: resumeStyles.text2,
                  h3: resumeStyles.text2,
                  h4: resumeStyles.text2,
                  h5: resumeStyles.text2,
                  h6: resumeStyles.text2,
                  p: resumeStyles.description,
                  strong: resumeStyles.strong,
                  italic: resumeStyles.italic,
                  ul: resumeStyles.ul,
                  li: resumeStyles.li,
                  br: resumeStyles.br,
                })}
              </Text>
              {project?.skills?.length > 0 && <Text style={resumeStyles.li_description}>Skills</Text>}
              {
                project?.skills?.length > 0 &&
                project.skills.map((skill, id) => (
                  <Text key={id} style={resumeStyles.li}>
                    {`• ${skill.skill}`}
                  </Text>
                ))
              }
              <Text style={resumeStyles.description}>{parseHtmlToPdf(project.description, {
                h1: resumeStyles.text1,
                h2: resumeStyles.text2,
                h3: resumeStyles.text2,
                h4: resumeStyles.text2,
                h5: resumeStyles.text2,
                h6: resumeStyles.text2,
                p: resumeStyles.description,
                strong: resumeStyles.strong,
                italic: resumeStyles.italic,
                ul: resumeStyles.ul,
                li: resumeStyles.li,
                br: resumeStyles.br,
              })}</Text>
            </View>
          ))}
        </View>
      }

      {/* ===== Certification Section ===== */}

      {
        profileData?.certifications?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <View style={resumeStyles.watermark}>
            <Text style={resumeStyles.watermarkText}>Prepared with Search O Pal</Text>
          </View>
          <Text style={resumeStyles.subheader}>Certifications</Text>
          {profileData.certifications.map((certification, idx) => (
            <View key={idx}>
              <Text style={resumeStyles.text1}>{certification.name}</Text>
              <Text style={resumeStyles.text2}>
                {certification.organization}
              </Text>
              <Text style={resumeStyles.text2}>
                {formatDate(certification.issue_date)} - {" "}
                {certification.end_date ? formatDate(certification.expiry_date) : "No Expiry"}
              </Text>
              <Text style={resumeStyles.description}>{certification.description}</Text>
            </View>
          ))}
        </View>
      }

      {/* ===== Training Section ===== */}

      {
        profileData?.trainings?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <Text style={resumeStyles.subheader}>Trainings</Text>
          {profileData.trainings.map((training, idx) => (
            <View key={idx}>
              <Text style={resumeStyles.text1}>{training.name}</Text>
              <Text style={resumeStyles.text2}>
                {training.organization}
              </Text>
              <Text style={resumeStyles.text2}>
                {formatDate(training.start_date)} - {" "}
                {training.end_date ? formatDate(training.end_date) : "Training in progress"}
              </Text>
              <Text style={resumeStyles.description}>{training.description}</Text>
            </View>
          ))}
        </View>
      }

      {/* ===== Education Section ===== */}

      {profileData?.educations?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <View style={resumeStyles.watermark}>
            <Text style={resumeStyles.watermarkText}>Prepared with Search O Pal</Text>
          </View>
          <Text style={resumeStyles.subheader}>Education</Text>
          {profileData.educations.map((edu, idx) => (
            <View key={idx}>
              <Text style={resumeStyles.text1}>{`${edu.degree} (${edu.category})`}</Text>
              <Text style={resumeStyles.text2}>
                {edu.institute} - {edu.city}, {edu.country}
              </Text>
              <Text style={resumeStyles.text2}>
                {formatDate(edu.start_date)} -{" "}
                {edu.end_date ? formatDate(edu.end_date) : "Currently Studying"}
              </Text>
              <Text style={resumeStyles.description}>{edu.description}</Text>
            </View>
          ))}
        </View>
      }

      {/* ===== Extra-Curricular Section ===== */}

      {profileData?.extra_curricular?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <Text style={resumeStyles.subheader}>Extra Curricular Activities</Text>
          {profileData.extra_curricular.map((activity, idx) => (
            <View key={idx}>
              <Text style={resumeStyles.description}>
                {parseHtmlToPdf(activity.description, {
                  h1: resumeStyles.text1,
                  h2: resumeStyles.text2,
                  h3: resumeStyles.text2,
                  h4: resumeStyles.text2,
                  h5: resumeStyles.text2,
                  h6: resumeStyles.text2,
                  p: resumeStyles.description,
                  strong: resumeStyles.strong,
                  italic: resumeStyles.italic,
                  ul: resumeStyles.ul,
                  li: resumeStyles.li,
                  br: resumeStyles.br,
                })}
              </Text>
            </View>
          ))}
        </View>
      }

      {/* ===== Publications Section ===== */}

      {profileData?.publications?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <View style={resumeStyles.watermark}>
            <Text style={resumeStyles.watermarkText}>Prepared with Search O Pal</Text>
          </View>
          <Text style={resumeStyles.subheader}>Publications</Text>
          {profileData.publications.map((publication, idx) => (
            <View key={idx}>
              <Text style={resumeStyles.description}>
                {parseHtmlToPdf(publication.description, {
                  h1: resumeStyles.text1,
                  h2: resumeStyles.text2,
                  h3: resumeStyles.text2,
                  h4: resumeStyles.text2,
                  h5: resumeStyles.text2,
                  h6: resumeStyles.text2,
                  p: resumeStyles.description,
                  strong: resumeStyles.strong,
                  italic: resumeStyles.italic,
                  ul: resumeStyles.ul,
                  li: resumeStyles.li,
                  br: resumeStyles.br,
                })}
              </Text>
            </View>
          ))}
        </View>
      }

      {/* ===== References Section ===== */}

      {profileData?.references?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <Text style={resumeStyles.subheader}>References</Text>
          {profileData.references.map((reference, idx) => (
            <View key={idx}>
              <Text style={resumeStyles.description}>
                {parseHtmlToPdf(reference.description, {
                  h1: resumeStyles.text1,
                  h2: resumeStyles.text2,
                  h3: resumeStyles.text2,
                  h4: resumeStyles.text2,
                  h5: resumeStyles.text2,
                  h6: resumeStyles.text2,
                  p: resumeStyles.description,
                  strong: resumeStyles.strong,
                  italic: resumeStyles.italic,
                  ul: resumeStyles.ul,
                  li: resumeStyles.li,
                  br: resumeStyles.br,
                })}
              </Text>
            </View>
          ))}
        </View>
      }

      {/* ===== Achievements Section ===== */}

      {profileData?.achievements?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <Text style={resumeStyles.subheader}>Achievements</Text>
          {profileData.achievements.map((achievement, idx) => (
            <View key={idx}>
              <Text style={resumeStyles.description}>
                {parseHtmlToPdf(achievement.description, {
                  h1: resumeStyles.text1,
                  h2: resumeStyles.text2,
                  h3: resumeStyles.text2,
                  h4: resumeStyles.text2,
                  h5: resumeStyles.text2,
                  h6: resumeStyles.text2,
                  p: resumeStyles.description,
                  strong: resumeStyles.strong,
                  italic: resumeStyles.italic,
                  ul: resumeStyles.ul,
                  li: resumeStyles.li,
                  br: resumeStyles.br,
                })}
              </Text>
            </View>
          ))}
        </View>
      }

      {/* ===== Volunteer Section ===== */}

      {profileData?.volunteer_work?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <View style={resumeStyles.watermark}>
            <Text style={resumeStyles.watermarkText}>Prepared with Search O Pal</Text>
          </View>
          <Text style={resumeStyles.subheader}>Volunteer Work</Text>
          {profileData.volunteer_work.map((volunteer, idx) => (
            <View key={idx}>
              <Text style={resumeStyles.description}>
                {parseHtmlToPdf(volunteer.description, {
                  h1: resumeStyles.text1,
                  h2: resumeStyles.text2,
                  h3: resumeStyles.text2,
                  h4: resumeStyles.text2,
                  h5: resumeStyles.text2,
                  h6: resumeStyles.text2,
                  p: resumeStyles.description,
                  strong: resumeStyles.strong,
                  italic: resumeStyles.italic,
                  ul: resumeStyles.ul,
                  li: resumeStyles.li,
                  br: resumeStyles.br,
                })}
              </Text>
            </View>
          ))}
        </View>
      }

      {/* ===== Skills Section ===== */}

      {profileData?.skills?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <View style={resumeStyles.watermark}>
            <Text style={resumeStyles.watermarkText}>Prepared with Search O Pal</Text>
          </View>
          <Text style={resumeStyles.subheader}>Skills</Text>
          <View style={resumeStyles.table}>
            {/* Table Header */}
            <View style={resumeStyles.tableRow}>
              <View style={resumeStyles.tableCol}>
                <Text style={resumeStyles.tableHeader}>Skill</Text>
              </View>
              <View style={resumeStyles.tableCol}>
                <Text style={resumeStyles.tableHeader}>Experience</Text>
              </View>
              <View style={resumeStyles.tableCol}>
                <Text style={resumeStyles.tableHeader}>Last Used</Text>
              </View>
            </View>
            {/* Table Data */}
            {profileData.skills.map((item) => (
              <View key={item.name} style={resumeStyles.tableRow}>
                <View style={resumeStyles.tableCol}>
                  <Text>{item.skill_name}</Text>
                </View>
                <View style={resumeStyles.tableCol}>
                  <Text>
                    {item.experience === "0"
                      ? "Less than 1 year"
                      : item.experience === "11"
                        ? "More than 10 years"
                        : item.experience === "1"
                          ? `${item.experience} Year`
                          : `${item.experience} Years`}
                  </Text>
                </View>
                <View style={resumeStyles.tableCol}>
                  <Text>
                    {item.last_used === "0"
                      ? "Currently Using"
                      : item.last_used === 1
                        ? "Less than 1 year ago"
                        : `${item.last_used} Years`}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </View>
      }

      {/* ===== Languages Section ===== */}

      {profileData?.languages?.length > 0 &&
        <View style={resumeStyles.detailSection}>
          <Text style={resumeStyles.subheader}>Languages</Text>
          <View style={resumeStyles.table}>
            {/* Table Header */}
            <View style={resumeStyles.tableRow}>
              <View style={resumeStyles.tableCol}>
                <Text style={resumeStyles.tableHeader}>Language</Text>
              </View>
              <View style={resumeStyles.tableCol}>
                <Text style={resumeStyles.tableHeader}>Proficiency</Text>
              </View>
            </View>
            {/* Table Data */}
            {profileData.languages.map((item) => (
              <View key={item.name} style={resumeStyles.tableRow}>
                <View style={resumeStyles.tableCol}>
                  <Text>{item.language_name}</Text>
                </View>
                <View style={resumeStyles.tableCol}>
                  <Text>{item.proficiency}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>
      }
    </Page>
  </Document>
);

export const parseHtmlToPdf = (html, styles) => {
  if (typeof window === "undefined") {
    return null;
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const renderNode = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return <Text style={styles.text}>{node.textContent}</Text>;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const children = Array.from(node.childNodes).map((child, index) =>
        renderNode(child)
      );

      switch (node.tagName.toLowerCase()) {
        case "h1":
          return (
            <Text key={node.textContent} style={resumeStyles.text1}>
              {children}
            </Text>
          );
        case "h2":
          return (
            <Text key={node.textContent} style={resumeStyles.text1}>
              {children}
            </Text>
          );
        case "h3":
          return (
            <Text key={node.textContent} style={resumeStyles.text1}>
              {children}
            </Text>
          );
        case "h4":
          return (
            <Text key={node.textContent} style={resumeStyles.text1}>
              {children}
            </Text>
          );
        case "h5":
          return (
            <Text key={node.textContent} style={resumeStyles.text1}>
              {children}
            </Text>
          );
        case "h6":
          return (
            <Text key={node.textContent} style={resumeStyles.text1}>
              {children}
            </Text>
          );
        case "ul":
          return <View key={node.textContent} style={resumeStyles.ul}>{children}</View>;
        case "ol":
          return <View key={node.textContent} style={resumeStyles.ol}>{children}</View>;
        case "li":
          return (
            <Text key={node.textContent} style={resumeStyles.li}>
              • {children}
            </Text>
          );
        case "p":
          return (
            <Text key={node.textContent} style={resumeStyles.description}>
              {children}
            </Text>
          );
        case "strong":
          return (
            <Text key={node.textContent} style={resumeStyles.strong}>
              {children}
            </Text>
          );
        case "em":
          return (
            <Text key={node.textContent} style={resumeStyles.italic}>
              {children}
            </Text>
          );
        case "br":
          return <Text key={Math.random()}>{"\n"}</Text>;
        default:
          return <Text>{children}</Text>;
      }
    }

    return null;
  };

  return renderNode(doc.body);
};